module.exports = __webpack_public_path__ + "img/md1bg1.2e6282ed.png";